import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';

const WidgetBreadcrumb = ({ data = null, isCate = false, ...props }: any) => {
  if (isEmpty(data)) return null;
  const _data = [
    {
      nameTh: isCate ? data?.category?.th : data?.section?.th,
      nameEng: isCate ? data?.category?.en : data?.section?.en,
      link: `/category/${isCate ? data?.category?.en : data?.section?.en || ''}`
    },
    {
      nameTh: data?.subCategory?.th,
      nameEng: data?.subCategory?.en,
      link: `/category/${isCate ? data?.category?.en : data?.section?.en || ''}/${data?.subCategory?.en || ''}`
    }
  ];
  return (
    <>
      <WidgetWrapper id='widget-breadcrumb' {...props}>
        <nav aria-label='breadcrumb'>
          <ul className='breadcrumb'>
            {_data.map(
              (item, index) =>
                item.nameEng && (
                  <li key={index} className='breadcrumb-item'>
                    {item.link ? <a href={item.link}> {item?.nameEng} </a> : <a href='/'> {item?.nameEng} </a>}
                  </li>
                )
            )}
          </ul>
        </nav>
      </WidgetWrapper>
    </>
  );
};

const WidgetWrapper = styled.div`
  position: relative;
  display: block;
  ul.breadcrumb {
    display: flex;
    li {
      text-transform: uppercase;
      &:not(:last-child) {
        &:after {
          content: '●';
          padding: 0 5px;
        }
      }
    }
    a {
      font-weight: 400;
      font-size: 24px;
    }
    svg {
      color: #242424;
      font-weight: 300;
      font-size: 16px;
      margin-right: 0.5rem;
    }
    .breadcrumb-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
  }
  @media (max-width: 768px) {
    ul.breadcrumb {
      a {
        font-size: 14px;
      }
    }
  }
`;

export default WidgetBreadcrumb;
